import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderInterceptor } from './interceptors/header.interceptor';
import { LoginComponent } from './login/login.component';
import { ConfigService } from './services/config.service';
import { EnvironmentService } from './services/environment.service';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const configFactory = (configService: ConfigService, envService: EnvironmentService) => {
    return () => configService.loadConfig()
        .then(() => { return envService.load() })
        .then(env => { envService.setEnv(env) })
};

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent
    ],
    exports: [
        RouterModule,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        RouterModule.forRoot([])], providers: [
            {
                provide: HTTP_INTERCEPTORS,
                useClass: HeaderInterceptor,
                multi: true
            },
            {
                provide: APP_INITIALIZER,
                useFactory: configFactory,
                deps: [ConfigService, EnvironmentService],
                multi: true
            },
            provideZoneChangeDetection({
                eventCoalescing: false, // comportamiento clásico
                runCoalescing: false
            }),
            provideCharts(withDefaultRegisterables()),
            provideHttpClient(withInterceptorsFromDi())
        ]
})
export class AppModule {
}
